import { defineMessages } from 'react-intl';

export const messages: {
	showingResultsFor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchInsteadFor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	didYouMean: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showingResultsFor: {
		id: 'search-page.auto-correction.showing-results-for',
		defaultMessage: 'Showing results for {replacementQuery}',
		description:
			'Message shown when auto-correction replaces the search query, where replacementQuery is a link to the corrected query',
	},
	searchInsteadFor: {
		id: 'search-page.auto-correction.search-instead-for',
		defaultMessage: 'Search instead for {originalQuery}',
		description:
			'Message shown with a link to search for the original query instead of the auto-corrected one',
	},
	didYouMean: {
		id: 'search-page.auto-correction.did-you-mean',
		defaultMessage: 'Did you mean {suggestedQuery}',
		description: 'Message suggesting an alternative search query, where suggestedQuery is a link',
	},
});
